import React from "react";
import { Link } from "react-router-dom";
import { Api } from "../app-controller.js";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import Swal from "sweetalert2";

class AsoPlanta extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      establecimientos: [],
      estados: ["Inactivo", "Activo", "En espera", "Rechazado"],
      nivelUsuario: localStorage.nivel_actual,
    };

    this.removeEst = this.removeEst.bind(this);
    this.getMisPlantas = this.getMisPlantas.bind(this);
    this.asoForm = {};
  }

  getMisPlantas() {
    Api.fetch("app/getMisPlantas", {}, "POST").then((data) => {
      this.setState({
        establecimientos: data,
      });
      Api.loading(0);
    });
  }

  removeEst(e) {
    let id = e.target.getAttribute("data-id");
    Swal.fire({
      title: "Atención",
      icon: "warning",
      text: "¿Seguro que desea continuar con la eliminación de la asociación?",
      confirmButtonText: "Continuar",
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
    }).then((result) => {
      Api.loading(1);
      if (result.isConfirmed) {
        Api.fetch("app/removeAssocPlanta", { id: id }, "POST").then((data) => {
          this.getMisPlantas();
        });
      }
    });
  }

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    Api.loading(1);
    this.getMisPlantas();

    let asociaFrm = {
      target: "#asociaForm",
      nombre: "asociaForma",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 7,
            name: "razon_social",
            type: "text",
            label: "Razón social: <span style=color:red>*</span>",
            onkeyup: "this.value = this.value.toUpperCase();",
          },
        },
        {
          input: {
            cols: 3,
            name: "guid",
            type: "text",
            label: "GUID: <span style=color:red>*</span>",
            onkeyup: "this.value = this.value.toUpperCase();",
            maxlength: 4,
          },
        },
        {
          button: {
            cols: 1,
            name: "asocia",
            label: "",
            text: "",
            class: "form-control btn-primary ",
            icon: "fas fa-plus",
            click: (e) => {
              let datos = this.asoForm.data();

              let existe = false;

              this.state.establecimientos.forEach((e) => {
                if (datos.guid === e.guid) {
                  existe = true;
                }
              });

              if (existe) {
                Swal.fire({
                  title: "Error",
                  icon: "warning",
                  text: "Ya cuentas con este establecimiento en tu lista.",
                  confirmButtonText: "Continuar",
                });
                return false;
              }

              if (
                datos.guid === undefined ||
                datos.razon_social === undefined
              ) {
                Swal.fire({
                  title: "Error",
                  icon: "warning",
                  text: "Todos los campos son requeridos.",
                  confirmButtonText: "Continuar",
                });
                return;
              }

              Api.loading(1);
              Api.fetch(
                "app/getValidEstablishmentByGUID",
                {
                  guid: datos.guid,
                  razon_social: datos.razon_social,
                  actividad: 12,
                },
                "POST"
              ).then((data) => {
                if (data.id) {
                  if (data.actividad_id !== "12") {
                    Swal.fire({
                      title: "Error",
                      icon: "warning",
                      text: 'Favor de ingresar un con actividad "Fabricante Nacional de subproducto origen animal"',
                    });
                  } else {
                    Api.fetch(
                      "app/setAssocPlanta",
                      { asociar_id: data.id },
                      "POST"
                    ).then((r) => {
                      if (r.data !== "1") {
                        Swal.fire({
                          title: "Atención",
                          icon: "error",
                          text: r.data,
                          confirmButtonText: "Continuar",
                        }).then((r) => {
                          this.getMisPlantas();
                          this.asoForm.clear();
                        });
                        return;
                      }
                      this.asoForm.clear();
                      this.getMisPlantas();
                      Swal.fire({
                        title: "Asociar establecimiento",
                        icon: "success",
                        text: "La solicitud de asociación fue enviada.",
                        confirmButtonText: "Continuar",
                      });
                    });
                  }
                } else {
                  Swal.fire({
                    title: "Error al ingresar el establecimiento",
                    icon: "warning",
                    text: "Favor de ingresar un establecimiento con licencia vigente.",
                  });
                }
              });
            },
          },
        },
      ],
    };

    this.asoForm = Api.form(asociaFrm);
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/comercializador/asociar">Solicitud</Link>
          </li>
          <li className="breadcrumb-item active">Asociar a planta</li>
        </ol>
        <h1 className="page-header">Asociar como comercializador a planta</h1>

        <div className="row">
          <Panel className="col-sm-12">
            <PanelBody>
              <fieldset className="col-sm-12">
                <legend>Asociar a planta </legend>
                <div id="asociaForm"></div>
              </fieldset>
              <fieldset className="col-sm-12">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th>RAZÓN SOCIAL</th>
                      <th>GUID</th>
                      <th>ESTADO</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.establecimientos.map((est, index) => (
                      <tr key={index} id={"t" + index}>
                        <td>{est.razon_social}</td>
                        <td>{est.guid}</td>
                        <td>
                          {this.state.estados[est.activo]
                            ? this.state.estados[est.activo]
                            : "Sin Enviar"}
                        </td>
                        <td>
                          <button
                            onClick={this.removeEst}
                            className="btn btn-warning"
                            data-id={est.id}
                          >
                            <i data-id={est.id} className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <hr />
                <div className="text-right">
                  Todos los campos marcados con{" "}
                  <span style={{ color: "red" }}>*</span> son requeridos.
                </div>
              </fieldset>
            </PanelBody>
          </Panel>
        </div>
      </div>
    );
  }
}

export default AsoPlanta;
